<template>
  <div :class="
    [
      `share__container`,
      transparent ? `share__container--transparent` : ``,
      sharingOpen || expanded ? `share__container--open` : ``
    ]
  ">
    <ul>
      <li>
         <a class="share__button" target="_blank" v-if="download" :href="download" :style="downloadStyles"></a>
      </li>
      <li>
         <span class="share__button" @click="toggleShare(`email`)" :style="emailStyles"></span>
      </li>
      <li>
         <span class="share__button" @click="toggleShare(`copy`)" :style="copyStyles"></span>
         <input class="share__button__input" ref="clipboardField" type="text" :value="link">
      </li>
      <li>
         <span class="share__button" @click="toggleShare(`twitter`)" :style="twitterStyles"></span>
      </li>
    </ul>
    <span v-if="!expanded" class="share__button" @click="toggleShare()" :style="shareButtonStyles"></span>

  </div>
</template>

<script>
import sharingIcon from '@/assets/images/share-icon.svg'
import sharingIconWhite from '@/assets/images/share-icon-white.svg'
import twitterIcon from '@/assets/images/twitter-icon.svg'
import emailIcon from '@/assets/images/email-icon.svg'
import downloadIcon from '@/assets/images/download-icon.svg'
import copyIcon from '@/assets/images/share-icon-black.svg'

export default {
  // Props
  props: {
    transparent: Boolean,
    link: String,
    download: String,
    expanded: Boolean
  },

  // Data
  data () {
    return {
      shareButtonStyles: {
        'background-image': `url(${(this.transparent) ? sharingIconWhite : sharingIcon})`
      },
      twitterStyles: {
        'background-image': `url(${twitterIcon})`
      },
      emailStyles: {
        'background-image': `url(${emailIcon})`
      },
      downloadStyles: {
        'background-image': `url(${downloadIcon})`
      },
      copyStyles: {
        'background-image': `url(${copyIcon})`
      },
      sharingOpen: false
    }
  },

  // Methods
  methods: {

    copyToClipboard () {
      this.$refs.clipboardField.select()
      document.execCommand('copy')
    },
    toggleShare (target) {
      if (this.link) {
        const content = encodeURIComponent(`Check out the first-ever Moda Operandi Runway Report, an analysis of Moda Operandi’s Trunkshow data that forecasts next season’s fashion trends, shopping behaviors, and geo patterns—as determined by the luxury fashion consumer. ${this.link}`)
        if (target === `email`) {
          window.location.href = `mailto:?body=${content}`
        }

        if (target === `twitter`) {
          window.open(`https://twitter.com/intent/tweet?text=${content}`, `_blank`)
        }

        if (target === `copy`) {
          this.copyToClipboard()
        }
      }
      this.sharingOpen = !this.sharingOpen
    }
  }
}
</script>
